import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Bottom-nav shell.
 *
 * Each tab is width-capped at 25% and the row ends in a flexible spacer, so
 * further tabs drop in without re-laying out the row — the reserved space is
 * the point.
 *
 * Settings is here because on mobile there was otherwise no way to reach it:
 * `/settings` was routed but only linked from the desktop header's avatar.
 */

const TABS = [
  { key: 'lists', label: 'Lists', icon: '☰', path: '/' },
  { key: 'settings', label: 'Settings', icon: '⚙', path: '/settings' },
] as const;

export function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="bottom-nav" aria-label="Sections">
      {TABS.map((tab) => {
        const active = tab.path === '/' ? pathname === '/' || pathname.startsWith('/lists') : pathname.startsWith(tab.path);
        return (
          <button
            key={tab.key}
            type="button"
            className={active ? 'bottom-nav__tab is-active' : 'bottom-nav__tab'}
            aria-current={active ? 'page' : undefined}
            onClick={() => navigate(tab.path)}
          >
            <span className="bottom-nav__icon" aria-hidden="true">
              {tab.icon}
            </span>
            {tab.label}
          </button>
        );
      })}
      {/* Reserved space for the tabs that come after v1. */}
      <span className="bottom-nav__spacer" aria-hidden="true" />
    </nav>
  );
}
